import React, {Component} from 'react';
import FormGroupSelectInput from "../formGroupSelectInput";
import '../../style/appFormRefSettings.css'
import Table from "../table";
import {Table as AragTable,CheckboxInput,SelectInput}  from "arag-ui-lib";
import SolicitorGroupHOC from '../../containers/SolicitorGroups/solicitorGroupHOC'
import Dots from 'react-activity/lib/Dots';
import '../../style/dots.css';
import FormResponseMessage from "./../formResponseMessage";
import Button from "../button";
import _ from 'lodash';
import ReactDOM from 'react-dom';
import CustomModal from "../General/customModal";
import ReferralSettingsCopyForm from "./referralSettingsCopyForm";
import { LEGAL_ADVICE_TEXT } from '../../helpers/variables';

class ApplicationFormReferralSettings extends Component{
    dropdownOptions = [
        {key: 'DoNotRefer',label:'Do Not Refer'},
        {key: 'TechnicalUnderwriter',label: 'Technical Underwriter'},
        {key: 'Underwriter',label: 'Underwriter'}
    ];

    componentDidUpdate(prevProps, prevState){
        if(!prevProps.Store.posting && this.props.Store.posting){
            ReactDOM.findDOMNode(this).scrollIntoView(false);
        }
    }

    onReferToChange = (evt) => {
                let conditionType = evt.target.name;
                let referTo = this.dropdownOptions.find(option=> option.key === evt.target.value).label;

                this.props.ChangeReferralTrigger(conditionType, referTo);
    }

    render() {
        const {
            isCopyModalOpen,
            openCopyModal,
            closeCopyModal,
            getSolicitorGroupCaseTypes,
            changeReferralSettingsState
        } = this.props;

        let columns = [
                {
                    propertyName: 'ConditionType',
                    header: 'Condition Type',
                    id: 'ConditionType',
                    style:{textAlign: 'left'},
                    sortable: false,
                    formatter: (row) => (<div style={{textAlign: 'left'}}>{row.conditionType}</div>)
                },
                {
                    propertyName: 'ReferTo',
                    header: 'Refer To',
                    id: 'ReferTo',
                    sortable: false,
                    style:{textAlign: 'left'},
                    formatter: (row) =>(
                       <SelectInput
                        value= {this.dropdownOptions.find(option=>option.label === row.referTo).key}
                        name={row.conditionType}
                        onChange={this.onReferToChange}
                        options={this.dropdownOptions}
                        components={ this.Option }
                    />)
                }
            ];

        let solicitorGroupOptions = [{key: '', value: 'None'}, ...this.props.Store.groups.map((group) => {
                return {key: group.id, value: group.name}
            }
        )];

        let caseTypes = this.props.Store.appType === 'custom' ? this.props.Store.caseTypes : this.props.allCaseTypes;
        let caseTypeOptions = [{key: '', value: 'None'}, ...caseTypes.map((caseType) => {
                return {key: caseType.id, value: caseType.name}
            }
        )];
        let subCaseTypes = this.props.Store.appType === 'custom' ? this.props.Store.subCaseTypes : this.props.allSubCaseTypes;
        let subCaseTypeOptions = [{key: '', value: 'None'}, ..._.filter(subCaseTypes, item => item.caseTypeId.toString() === this.props.Store.selectedCaseType).map((subCaseType) => {
                return {key: subCaseType.id, value: subCaseType.name}
            }
        )];

        let tableHeaders = [
            {
                key: 'Visible',
                value: 'Visible',
                style: 'col-sm-1'
            },
            {
                key: 'Question',
                value: 'Question',
                style: 'col-sm-3'
            },
            {
                key: 'Type',
                value: 'Type',
                style: 'col-sm-1'
            },
            {
                key: 'Options',
                value: 'Options',
                style: 'col-sm-1'
            },
            {
                key: 'Technical Underwriter',
                value: 'Technical Underwriter',
                style: 'col-sm-3'
            },
            {
                key: 'Underwriter',
                value: 'Underwriter',
                style: 'col-sm-3'
            },
        ];

        let groupSolicitors;
        if (this.props.Store.selectedGroup)
            groupSolicitors = this.props.GroupSolicitors();

        return (
            <div className="row">
                {isCopyModalOpen && (
                    <CustomModal
                        isOpen={isCopyModalOpen}
                        content={<ReferralSettingsCopyForm
                            groupCaseAndSubTypes={this.props.Store.caseTypes}
                            getSolicitorGroupCaseTypes={getSolicitorGroupCaseTypes}
                            closeCopyModal={closeCopyModal}
                            solicitorGroups={this.props.Store.groups}
                            caseTypes={this.props.allCaseTypes}
                            subCaseTypes={this.props.allSubCaseTypes}
                            changeReferralSettingsState={changeReferralSettingsState}
                        />}
                        handleClose={closeCopyModal}
                    />
                )}
                <div className="col-sm-12 appFormRefSettings-comp-wrapper">
                    {
                        this.props.Store.openModal ?
                            <div className="appFormRefSettings-modal">
                                <div className="appFormRefSettings-modal-content">
                                    <div className="appFormRefSettings-close-button"
                                         onClick={() => this.props.ChangeField('openModal', false)}></div>
                                    <SolicitorGroupHOC />
                                </div>
                            </div>
                            :
                            null
                    }
                    <div className="row">
                        <h2 className="col-sm-12 appFormRefSettings-h2">Application Form & Referral Settings</h2>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 appFormRefSettings-app-type-wrapper">
                            {this.props.Store.appType === 'custom' ?
                                <div className="appFormRefSettings-app-type-active text-center"
                                     onClick={() => this.props.ChangeField('appType', 'custom')}>
                                    Custom
                                </div>
                                :
                                <div className="appFormRefSettings-app-type text-center"
                                     onClick={() => this.props.ChangeField('appType', 'custom')}>
                                    Custom
                                </div>
                            }
                            {this.props.Store.appType === 'default' ?
                                <div className="appFormRefSettings-app-type-active text-center"
                                     onClick={() => this.props.ChangeField('appType', 'default')}>
                                    Default
                                </div>
                                :
                                <div className="appFormRefSettings-app-type text-center"
                                     onClick={() => this.props.ChangeField('appType', 'default')}>
                                    Default
                                </div>
                            }
                        </div>
                    </div>

                    <div>
                        {this.props.Store.appType !== 'caseReferralKeywords' && (
                            <div className="row">
                                <div className="col-sm-12 ">
                                    <Button
                                        wrapper="btn-wrapper"
                                        btnType="button"
                                        clickHandler={() => this.props.ChangeField('openModal', true)}
                                        btnStyle={'btn btn-primary btn-xs sharp white'}
                                        label={`Create New ${LEGAL_ADVICE_TEXT} Group`}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="row">
                            <div className="col-sm-12">
                                <hr className="appFormRefSettings-hr"/>
                            </div>
                        </div>
                        <form className="form-horizontal" onSubmit={this.props.ViewEditForm}>
                            {(this.props.Store.appType === 'custom') && (
                                <FormGroupSelectInput
                                    Label={`${LEGAL_ADVICE_TEXT} Group`}
                                    LeftWrapper="col-sm-2"
                                    Value={this.props.Store.selectedGroup}
                                    Name="selectedGroup"
                                    HandleInputChange={(evt) => this.props.handleSolicitorGroupChange(evt.target.name, evt.target.value)}
                                    Options={solicitorGroupOptions}
                                    CenterWrapper="col-sm-6"
                                    Required={true}
                                    SelectStyle={'form-control formGroupSelectInput-select'}
                                    RightWrapper={"col-sm-4"}
                                    rightData={(
                                        <div>
                                            { (this.props.Store.selectedGroup !== '') && (
                                                <div>
                                                    <div className="appFormRefSettings-view-sol-wrapper">
                                                        <svg className="appFormRefSettings-view-sol-wrapper-arrow"
                                                             xmlns="http://www.w3.org/2000/svg"
                                                             viewBox="0 0 7.2 12"><title>Asset 1</title>
                                                            <g id="Layer_2" data-name="Layer 2">
                                                                <g id="info">
                                                                    <path
                                                                        d="M7.2,5.94a1.22,1.22,0,0,0-.36-.87L2.11.36A1.22,1.22,0,0,0,.39,2.09L4.26,5.95l-3.91,4a1.22,1.22,0,1,0,1.74,1.72L6.85,6.8a1.22,1.22,0,0,0,.35-.86Z"/>
                                                                </g>
                                                            </g>
                                                        </svg>
                                                        <span
                                                            onClick={() => this.props.ChangeField('viewSolicitors', !this.props.Store.viewSolicitors)}>View {LEGAL_ADVICE_TEXT}s</span>
                                                    </div>
                                                    {
                                                        this.props.Store.viewSolicitors ?
                                                            <ul className="appFormRefSettings-agents-list">
                                                                {groupSolicitors.map(solicitor => {
                                                                    return <li
                                                                        key={solicitor.lawsysFirmId}>{solicitor.lawsysFirm}</li>
                                                                })}
                                                            </ul>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            )
                            }
                            <FormGroupSelectInput
                                Label="Case Type" LeftWrapper="col-sm-2"
                                Value={this.props.Store.selectedCaseType}
                                Name="selectedCaseType"
                                HandleInputChange={this.props.HandleInputChange}
                                Options={caseTypeOptions}
                                CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                                RightWrapper="" Required={true}
                                SelectStyle={'form-control formGroupSelectInput-select'}

                            />
                            {
                                (this.props.Store.selectedCaseType !== '' && (subCaseTypeOptions.length > 1)) ?
                                    <FormGroupSelectInput
                                        Label="Sub Case Type" LeftWrapper="col-sm-2"
                                        Name="selectedSubCaseType"
                                        Value={this.props.Store.selectedSubCaseType}
                                        Options={subCaseTypeOptions}
                                        HandleInputChange={this.props.HandleInputChange}
                                        CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                                        RightWrapper=""
                                        SelectStyle={'form-control formGroupSelectInput-select'}

                                    />
                                    :
                                    null
                            }
                            <div className="form-group">
                                <div className="col-sm-2">
                                </div>
                                <div className="col-sm-3 appFormRefSettings-edit-wrapper">
                                    <input className="btn appFormRefSettings-edit" type="submit"
                                           value="View / Edit"/>
                                    <svg className="appFormRefSettings-edit-arrow" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 7.2 12"><title>Asset 1</title>
                                        <g id="Layer_2" data-name="Layer 2">
                                            <g id="info">
                                                <path
                                                    d="M7.2,5.94a1.22,1.22,0,0,0-.36-.87L2.11.36A1.22,1.22,0,0,0,.39,2.09L4.26,5.95l-3.91,4a1.22,1.22,0,1,0,1.74,1.72L6.85,6.8a1.22,1.22,0,0,0,.35-.86Z"/>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </form>
                        <div className="row">
                            <div className="col-sm-12">
                                <hr className="appFormRefSettings-hr"/>
                            </div>
                        </div>
                    </div>
                    {
                        (this.props.Store.showTable) ?
                            <div className="">
                                {
                                    this.props.Store.fetching ?
                                        <div className="form-group">
                                            <div className="col-sm-3"></div>
                                            <div className="col-sm-6">
                                                <div className="col-sm-5"></div>
                                                <Dots/>
                                            </div>
                                        </div>
                                        :
                                        <div>
                                            <Button
                                                clickHandler={openCopyModal}
                                                wrapper="btn-wrapper-forForms"
                                                btnType="button"
                                                btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                                label="Create New Based On Current"
                                            />
                                            <AragTable
                                                striped
                                                columns={ columns}
                                                data={this.props.Store.referralTriggersSettings}
                                            />
                                            <Table
                                                handleSelectMultipleValue={this.props.handleSelectMultipleValue}
                                                handleSelectMultipleChange={this.props.handleSelectMultipleChange}
                                                posting={this.props.Store.posting}
                                                requestPatchPolicyQuestionsGroup={this.props.requestPatchPolicyQuestionsGroup}
                                                groupedQuestions={this.props.groupedQuestions}
                                                changeRefSettingsInfoState={this.props.changeRefSettingsInfoState}
                                                infoState={this.props.Store.infoState}
                                                Questions={this.props.Store.questions}
                                                Headers={tableHeaders}
                                                Triggers={this.props.Store.questionTriggers}
                                                ChangeQuestionTrigger={this.props.ChangeQuestionTrigger}
                                                HandleCheckedState={this.props.HandleCheckedState}
                                                HandleCheckBoxChange={this.props.HandleCheckBoxChange}
                                                SelectQuestion={this.props.SelectQuestion}
                                                CalculateChildQuestionOptionName={this.props.CalculateChildQuestionOptionName}
                                            />
                                            <Button wrapper="btn-wrapper-ref-setting" btnType="button"
                                                    clickHandler={() => this.props.HandleSubmit() }
                                                    btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                                    label="Save Application Form & Referral Settings"/>
                                        </div>
                                }
                            </div>
                            :
                            <div>
                                {
                                    this.props.Store.fetchingFilteredPolicy?
                                        <div className="form-group">
                                            <div className="col-sm-3"></div>
                                            <div className="col-sm-6">
                                                <div className="col-sm-5"></div>
                                                <Dots/>
                                            </div>
                                        </div>
                                        :
                                        null
                                }
                            </div>
                    }
                    {
                        this.props.Store.posting ?
                            <div>
                                <div className="col-sm-5"></div>
                                <div className="col-sm-4"><Dots /></div>
                            </div>
                            :
                            null
                    }
                    {
                        this.props.Store.msg !== '' ?
                            <FormResponseMessage LeftWrapper="" CenterWrapper="" MessageStyle="formResponseMessage-success"
                                                 Message={this.props.Store.msg}/>
                            :
                            null
                    }
                    {
                        this.props.Store.badMsg !== '' ?
                            <FormResponseMessage LeftWrapper="" CenterWrapper="" MessageStyle="formResponseMessage-reject"
                                                 Message={this.props.Store.badMsg}/>
                            :
                            null
                    }
                </div>
            </div>
        )
    }
}

export default ApplicationFormReferralSettings;
